// extracted by mini-css-extract-plugin
export default {"list":"checkout_list__Ks1cO","list-item":"checkout_list-item__T3wLS","list-item-bisected":"checkout_list-item-bisected__xQlyv","required":"checkout_required__owPZc"};